import { useObserver } from "mobx-react";
import React from "react";
import { compact } from "lodash";
import { Grid, Input } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import Select from "@components/Select";
import { CustomerSelectorStore, SearchFilter } from "./CustomerSelectorStore";
import { store as st } from "@store";
import { omit } from "@bonliva-crm/common";
import { NoCustomerGroupOption } from "@customers/CustomerSearch/utils";

type Props = {
  store: CustomerSelectorStore;
  disabledFilterFields: Array<keyof SearchFilter>;
};

export function CustomerSelectorFilter(props: Props) {
  const { store } = props;

  const setText = (v: string) => {
    store.setFilter({ text: v, sort: v ? "relevance" : "name_asc" });
  };
  const setCustomerGroup = (v: string[]) =>
    store.setFilter({
      group: compact(v)
    });
  const setCustomerNumber = (v: string) => store.setFilter({ customerNumber: v });

  const groups = [
    omit(NoCustomerGroupOption, "parent"),
    ...st().cache.customerGroups.toLabelValue()
  ];

  return useObserver(() => (
    <Grid container spacing={1} alignItems="flex-end" style={{ flex: "0 0 auto" }}>
      <Grid item xs={12}>
        <Input
          autoFocus
          name="text"
          fullWidth
          placeholder={locale.Search}
          onChange={(e) => setText(e.target.value)}
          value={store.filter.text}
        />
      </Grid>

      <Grid item xs={6}>
        <Select
          // onClear={store.filter.group.length > 0 ? () => setCustomerGroup(null) : null}
          clearable
          fullWidth
          multi
          options={groups}
          onChange={(e) => setCustomerGroup(e)}
          value={store.filter.group || null}
          label={locale.CustomerGroups}
          optionType={"checkbox"}
          // SelectProps={{ "aria-label": "Without label" }}
        />
      </Grid>

      <Grid item xs={3}>
        <Input
          name="customerNumbers"
          fullWidth
          onChange={(e) => setCustomerNumber(e.target.value)}
          value={store.filter.customerNumber}
          placeholder={locale.CustomerNumberShort}
        />
      </Grid>

      {/*<Grid item xs={3}>*/}
      {/*  <SortOptions*/}
      {/*    sortOptions={getSortOptions(store.filter.sort)}*/}
      {/*    onSortOption={(v) => this.setFilterSort(v.value as SortOption)}*/}
      {/*  />*/}
      {/*</Grid>*/}
    </Grid>
  ));
}
